import { useEffect, useRef, useState } from 'react';
import { copyLink } from '../../utils/clipboard';
import { IconCheck, IconLinkSimple } from '../icons';

/* Copy link with its own confirmation: the button itself flips to "Copied ✓"
   for a moment, so the click is acknowledged where the eye already is (the
   toast still fires for anyone who missed it). Disabled when there is no link
   yet rather than copying an empty string. `mini` is the design's green pill
   (.mini-row-copy) for tight rows: link icon + label, and the CSS drops the
   label to a round icon button when the card is narrow. */
export default function CopyLinkButton({ url, label = 'Copy link', className = 'btn btn-ghost btn-sm', title, mini = false }) {
  const [copied, setCopied] = useState(false);
  const timer = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  const handleClick = () => {
    if (!url) return;
    copyLink(url);
    setCopied(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setCopied(false), 1800);
  };

  return (
    <button
      className={className}
      disabled={!url}
      title={url ? title || url : 'No shareable link yet'}
      aria-label={mini ? title || label : undefined}
      onClick={handleClick}
      style={copied ? { color: 'var(--green)', borderColor: 'var(--green-border)' } : undefined}
    >
      {mini ? (
        <>
          {copied ? <IconCheck /> : <IconLinkSimple />}
          <span className="lb">{copied ? 'Copied' : label}</span>
        </>
      ) : copied ? (
        <>✓ Copied</>
      ) : (
        <>
          <img className="btn-icon-img" src="/assets/icons/link.svg" alt="" />
          {label}
        </>
      )}
    </button>
  );
}
